import { useState } from "react";
import { Outlet } from "react-router-dom";
import { ArrowBigLeftIcon, ArrowBigRight } from 'lucide-react';
import Sidebar from "./Sidebar";
import Headerbar from "./Headerbar";


const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden relative">
      {/* Toggle Button for mobile */}
      <div className={`z-50 w-65 transition-transform duration-300 lg:hidden absolute top-3 flex items-center justity-end ${
        isSidebarOpen? 'translate-x-0 left-60' : '-translate-x-full left-60'
      } lg:translate-x-0`}>
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="w-10 h-10 bg-gray-400 hover:bg-white border-1 border-[#E7EFFF] text-white hover:text-[#E7EFFF] p-2 shadow cursor-pointer rounded-full"
        >
          {/* ☰ */}
          {isSidebarOpen && <ArrowBigLeftIcon />}
          {!isSidebarOpen && <ArrowBigRight />}
        </button>
      </div>
      

      {/* Sidebar */}
      <div className={`
          absolute lg:relative z-40 top-0 left-0 h-full w-65 bg-white border-r border-[#E9EAEB] shadow-md transition-transform duration-300
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0
        `}
      >
        <Sidebar />
      </div>

      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div onClick={() => setIsSidebarOpen(false)}
          className="absolute inset-0 bg-opacity-25 z-30 md:hidden"
        ></div>
      )}

      {/* Main Content */}
      <div className="flex-1 overflow-auto bg-gradient-to-r from-[#FFFFFF] to-[#E7EFFF]">
        <Headerbar />
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
